import { createReducer } from '@reduxjs/toolkit';
import { OrderEnum } from 'enums/orderEnum';
import {
  checkErrorProjectSuccess,
  checkProjectClear,
  checkProjectSuccess,
  getProjectChangedContentSuccess,
  getProjectLanguagesSuccess,
  getProjectsSuccess,
  getProjectWorkflowStepsSuccess,
  getXTMCustomersForUserSuccess,
  getXTMRequestersForProjectSuccess,
  setProjectSearch,
  setProjectsPagination,
} from './projects.actions';
import { IProjectState } from './projects.interface';

const checkIfFiltered = (filters: Record<string, string | Array<string>>, search: string): boolean => {
  return (
    !!Object.keys(filters).find((key) => (Array.isArray(filters[key]) ? filters[key].length : filters[key])) || !!search
  );
};

const initState: IProjectState = {
  pagination: {
    page: 0,
    size: 10,
    order: OrderEnum.DESC,
    orderBy: 'project.createdAt',
    imported: false,
  },
  isFiltered: false,
  totalPages: 0,
  projectCheckArray: { projects: {}, checked: false },
  projectErrorArray: {},
  projectLanguages: [],
  projectWorkflowSteps: [],
  changedProducts: [],
  xtmCustomers: [],
  xtmRequesters: [],
  search: '',
};

export const projectsReducer = createReducer(initState, (builder) =>
  builder
    .addCase(getProjectsSuccess, (state, { payload: { content, totalPages } }) => {
      state.data = content;
      state.totalPages = totalPages;
    })
    .addCase(checkProjectSuccess, (state, { payload }) => {
      state.projectCheckArray = payload;
    })
    .addCase(checkProjectClear, (state) => {
      state.projectCheckArray = { projects: {}, checked: false };
    })
    .addCase(getProjectLanguagesSuccess, (state, { payload }) => {
      state.projectLanguages = payload;
    })
    .addCase(checkErrorProjectSuccess, (state, { payload }) => {
      state.projectErrorArray = payload;
    })
    .addCase(getProjectWorkflowStepsSuccess, (state, { payload }) => {
      state.projectWorkflowSteps = payload;
    })
    .addCase(getProjectChangedContentSuccess, (state, { payload }) => {
      state.changedProducts = payload;
    })
    .addCase(getXTMCustomersForUserSuccess, (state, { payload }) => {
      state.xtmCustomers = payload;
    })
    .addCase(getXTMRequestersForProjectSuccess, (state, { payload }) => {
      state.xtmRequesters = payload;
    })
    .addCase(setProjectSearch, (state, { payload }) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { page, size, order, orderBy, forceUpdate, ...rest } = state.pagination;
      const filters = rest as { [key: string]: string | string[] };

      state.search = payload;
      state.isFiltered = checkIfFiltered(filters, payload);
    })
    .addCase(setProjectsPagination, (state, { payload }) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { page, size, order, orderBy, forceUpdate, ...rest } = payload;
      const filters = rest as { [key: string]: string | string[] };

      state.isFiltered = checkIfFiltered(filters, state.search);
      state.pagination = payload;
    }),
);
